import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  fetchModerationFiltersConfigs,
  saveModerationFiltersConfigs
} from './moderationFilterActions';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  ModerationFiltersConfigsResponse,
  SaveModerationFiltersPayload
} from './moderationFiltersTypes';
import { getModerationFiltersConfigs } from './moderationFiltersApi';
import {
  parseModerationFiltersConfigs,
  prepareModerationFiltersConfig
} from './moderationFiltersUtils';
import {
  setDataScienceModelMap,
  setModerationFilters,
  updateModerationFilters
} from './moderationFiltersSlice';
import { setSpotConfig } from '@host-panel/request/config';
import ErrorNotifier, { Severity } from '../../../../../services/error-notifier';
import { State } from 'state';

function* fetchModerationFiltersConfigsSaga(action: PayloadAction<string>) {
  try {
    // todo: check configs for different spots
    const configs: ModerationFiltersConfigsResponse = yield call(
      getModerationFiltersConfigs,
      action.payload
    );

    const [parsedConfigs, dataScienceModelsMap] = parseModerationFiltersConfigs(configs);

    yield put(setModerationFilters(parsedConfigs));
    yield put(setDataScienceModelMap(dataScienceModelsMap));
  } catch (error) {
    console.error(error);
    ErrorNotifier.notifyError(`Failed to fetch moderation filters (thresholds)`, {
      level: Severity.Critical
    });
  }
}

function* saveModerationFiltersConfigsSaga(action: PayloadAction<SaveModerationFiltersPayload>) {
  const { spotId, configs, onResult } = action.payload;

  let isSuccess = true;

  try {
    const dataScienceModelsMap = yield select(
      (state: State) => state.settings.policy.moderationFilters.dataScienceModelMap
    );
    const isUsernameModelEnabled = yield select(
      (state: State) => state.settings.policy.flags.isUsernameModerationEnabled
    );

    const preparedConfigs = prepareModerationFiltersConfig(
      configs,
      dataScienceModelsMap,
      isUsernameModelEnabled
    );

    yield call(setSpotConfig, spotId, preparedConfigs);

    yield put(updateModerationFilters(configs));
  } catch (error) {
    isSuccess = false;
    console.error(error);
    ErrorNotifier.notifyError(`Failed to save moderation filters`, {
      level: Severity.Critical,
      moderationFilters: configs
    });
  }

  onResult?.(isSuccess);
}

export function* moderationFiltersSagas() {
  yield takeLatest(fetchModerationFiltersConfigs, fetchModerationFiltersConfigsSaga);
  yield takeLatest(saveModerationFiltersConfigs, saveModerationFiltersConfigsSaga);
}
